import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin } from 'lucide-react';
import { GlassPage } from '../components/chrome';

const Team = () => {
  return (
    <GlassPage>
      {/* Hero Section */}
      <section className="relative flex flex-col justify-center px-6 md:px-12 pt-40 pb-12">
        <div className="max-w-6xl mx-auto w-full">
          <h1 className="text-[12vw] md:text-[6vw] font-bold leading-[0.9] tracking-tighter mb-10 uppercase text-zinc-900">
            Our<br/>Team
          </h1>
          <p className="text-lg md:text-xl text-zinc-500 font-medium max-w-2xl">
            Meet the founder building the future of assistive technology.
          </p>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-12 md:py-16 px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="glass p-8 md:p-12 transition-all duration-300">
            <div className="flex flex-col gap-8 md:gap-12">
              <div className="flex-1 space-y-6">
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <h2 className="text-4xl md:text-5xl font-bold tracking-tighter mb-3 text-zinc-900">
                      Alexei Kvorosten
                    </h2>
                    <p className="text-sm md:text-base uppercase tracking-widest text-zinc-400 font-bold mb-4">
                      Founder & CEO
                    </p>
                    <p className="text-sm text-zinc-500">
                      <span className="font-bold">Location:</span> Boston, Massachusetts
                    </p>
                  </div>
                  <a
                    href="https://www.linkedin.com/in/alexei-kvorosten-62b460369/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-3 glass-pill text-zinc-700 hover:bg-zinc-900 hover:text-white transition-all group flex-shrink-0"
                    aria-label="LinkedIn"
                  >
                    <Linkedin size={24} className="group-hover:scale-110 transition-transform" />
                  </a>
                </div>

                <div className="space-y-4 text-zinc-500 leading-relaxed">
                  <p>
                    Alexei founded Korsa with a vision to enhance human communication through cognitive technology.
                    He leads the company to create smart glasses that help people communicate in their everyday life.
                  </p>
                  <p>
                    Based in Boston, Massachusetts, Alexei is passionate about building technology that makes a meaningful
                    impact on the world, focusing on accessibility and inclusivity in design.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Join Section */}
          <div className="glass-strong p-8 md:p-12 mt-8">
            <h3 className="text-2xl md:text-3xl font-bold tracking-tighter mb-4 text-zinc-900">
              Join Our Team
            </h3>
            <p className="text-zinc-500 mb-6">
              Looking for talented individuals who share our passion for assistive technology.
              Explore open positions and help us shape the future.
            </p>
            <Link to="/careers" className="btn-dark">
              View Open Positions
            </Link>
          </div>
        </div>
      </section>
    </GlassPage>
  );
};

export default Team;
